import { MqttCombination } from '@/shared/DefaultValues'
import { getFormatMessage } from '@/utils/utils'
import { Layout, message } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import Sider from 'antd/lib/layout/Sider'
import React, { useEffect, useState } from 'react'
import {
  TemplateTransferProps,
  TransferFunctionItem,
  TransferItem
} from '../interface'
import { TemplateTransferConfig } from './config'
import { TemplateTransferConnection } from './connection'
import { TemplateTransferProtocol } from './protocol'

export const TemplateTransfer: React.FC<TemplateTransferProps> = (
  props: TemplateTransferProps
) => {
  const [level, setLevel] = useState<number>(0)
  const [transferItem, setTransferItem] = useState<TransferItem>({})
  const [funcs, setFuncs] = useState<TransferFunctionItem[]>([])
  const formatMessage = getFormatMessage()

  const handleFunctionCreate = (
    item: TransferFunctionItem,
    combinations: MqttCombination[]
  ) => {
    const items = [...funcs]
    const index = items.findIndex((x) => x.id == item.id)
    if (index >= 0) {
      items[index] = item
    } else {
      items.push(item)
    }
    const newItem = { ...transferItem }
    newItem.function_config = items
    newItem.items_config = combinations.map((x) => {
      return { id: x.id, format: x.format }
    })
    setTransferItem(newItem)
    if (props.onFormSubmit) {
      props.onFormSubmit(newItem)
    }
  }

  const handleFunctionDelete = (item: TransferFunctionItem) => {
    const items = funcs.filter((x) => x.id != item.id)
    transferItem.function_config = items
    setTransferItem({ ...transferItem })
    if (props.onFormSubmit) {
      props.onFormSubmit(transferItem)
    }
  }

  const handleSelect = (level: number, item?: TransferItem) => {
    setLevel(level)
    if (item) {
      setTransferItem(item)
    }
  }

  const handleDeleteItem = (item: TransferItem) => {
    setTransferItem({})
    setFuncs([])
    if (props.onDelete) {
      props.onDelete(item)
    }
  }

  const handleSearch = (args: { name?: string; function?: string }) => {
    let items = transferItem.function_config || []
    if (args.name) {
      items = items.filter((x) => x.name?.includes(args.name || ''))
    }
    if (args.function) {
      items = items.filter((x) => x.function?.includes(args.function || ''))
    }
    setFuncs(items)
  }

  const handleFunctionValidate = (
    result: boolean,
    item: TransferFunctionItem
  ): boolean => {
    const exist = funcs.find((x) => x.name === item.name && x.id !== item.id)
    if (exist) {
      message.error('功能名称已存在')
      return false
    }
    return true
  }

  const handleFormValidate = (ok: boolean, item: TransferItem): boolean => {
    const exist = props.data?.find(
      (x) =>
        x.server_config?.config_name === item.server_config?.config_name &&
        x.id !== item.id
    )
    if (exist) {
      message.error(
        formatMessage({ id: 'app.template.transfer.protocol.name.exists' })
      )
      return false
    }

    if (item.server_config?.client_id !== '$uuid') {
      const clientIdExists = props.data?.find(
        (x) =>
          x.server_config?.client_id === item.server_config?.client_id &&
          x.id !== item.id
      )
      if (clientIdExists) {
        message.error(
          formatMessage({
            id: 'app.template.transfer.protocol.clientId.exists'
          })
        )
        return false
      }
    }
    return true
  }

  useEffect(() => {
    if (transferItem) {
      if (
        transferItem.function_config &&
        Array.isArray(transferItem.function_config)
      ) {
        setFuncs(transferItem.function_config)
      } else {
        setFuncs([])
      }
    }
  }, [transferItem])

  return (
    <Layout style={{ minHeight: '300px' }} hasSider={true}>
      <Sider width={200} style={{ backgroundColor: '#FFF' }}>
        <TemplateTransferProtocol
          {...props}
          onFormValidate={handleFormValidate}
          onSelect={handleSelect}
          onDelete={handleDeleteItem}
        />
      </Sider>
      <Content style={{ backgroundColor: '#FFF' }}>
        {level == 0 && <TemplateTransferConfig {...props} />}
        {level == 2 && (
          <TemplateTransferConnection
            data={funcs}
            variables={props.variables}
            alarms={props.alarms}
            combinations={props.combinations}
            enableCache={transferItem.server_config?.offline_caching}
            onDelete={handleFunctionDelete}
            onFormSubmit={handleFunctionCreate}
            onSearch={handleSearch}
            onFormValidate={handleFunctionValidate}
          />
        )}
      </Content>
    </Layout>
  )
}
